export default {
  methods: {
    getLibraryDetailUrl (product) {
      if(product.vod_ref_id && product.has_show) {
        return '/library/' + (Array(8).join('0') + product.vod_ref_id ).slice( -8 ) + '.html';
      }
      return '';
    }
  }
}